<template>
  <div class="rich-system">
    {{ text }}
  </div>
</template>

<style lang="sass">
.rich-system
  font-size: 14px
  font-style: italic
  color: #747576
  text-align: center
</style>

<script>
export default {
  name: 'RichSystem',
  props: {
    text: {
      type: String,
      default: null
    }
  }
}
</script>
